import React, { useState } from 'react'
import LgyCheckbox from 'app/components/util/lgy-checkbox/LgyCheckbox'
import LgyModalDialog from 'app/components/util/lgy-modal-dialog/LgyModalDialog'

/**
 * Like a normal LgyCheckbox but displays a warning message when the value changes
 * 
 * @author Alex Clary
 * @author Robbie Hinojosa
 * 
 * @param {Object} props redux-form compliant props
 */
const UserIsAffiliateCheckbox = (props) => {
  const [modalDismissed, setModalDismissed] = useState(false)
  const isUserAffiliate = props.meta.initial
  const isUserAffiliateCheckboxChecked = props.input.value
  return (<>
    {isUserAffiliate && !isUserAffiliateCheckboxChecked &&
      <LgyModalDialog show={!modalDismissed}>
        <div style={{ maxWidth: '350px' }} className='usa-grid'>
          <h4 style={{ textAlign: 'center' }}>WARNING</h4>
          <p className='usa-content'>You have unchecked "Affiliate User", which will change this user to an INTERNAL USER.</p>
          <p className='usa-content'>Please confirm this choice by clicking "Continue" and then "Submit".</p>
          <hr/>
          <button className='usa-button' style={{ width: '100%' }} onClick={() => { setModalDismissed(true) }} >Continue</button>
        </div>
      </LgyModalDialog>}
    <LgyCheckbox {...props} />
    {props.meta.dirty && <span>Be sure to set the applications/roles/entities correctly for the user in AccessManager</span>}
  </>)
}
export default UserIsAffiliateCheckbox